import {CASH_FUND_TYPE, INTERNAL_GIFT_CARD_PRODUCT_TYPE} from '../../constants';

export const getTransactionIdFromItem = item =>
  item.financialAccountTransactionId ||
  item.transactionId ||
  item.transferTransactionId ||
  null;

export const mapTransactionsById = (transactions = []) =>
  transactions.reduce((acc, transaction) => {
    if (!transaction?.id) {
      return acc;
    }

    acc[transaction.id] = transaction;

    return acc;
  }, {});

export const getTransactionsFromResponse = (response = null) => {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  return [];
};

export const mergeCashFundPaymentStatus = (
  purchasers = [],
  transactionsById = {},
) =>
  purchasers.map(purchaser => {
    const purchaserItems = Array.isArray(purchaser.items)
      ? purchaser.items
      : [];

    return {
      ...purchaser,
      items: purchaserItems.map(item => {
        if (item.type !== CASH_FUND_TYPE) {
          return item;
        }

        const itemTransactionId = getTransactionIdFromItem(item);
        const transaction = itemTransactionId
          ? transactionsById[itemTransactionId]
          : null;

        return {
          ...item,
          paymentTransactionCategory:
            transaction?.category || item.category || null,
          paymentTransactionStatus: transaction?.status || item.status || null,
        };
      }),
    };
  });

export const mergeCashFundAvailability = (
  purchasers = [],
  cashPurchases = [],
) => {
  const availabilityByPurchaseId = new Map(
    cashPurchases.map(cashPurchase => [String(cashPurchase.id), cashPurchase]),
  );

  return purchasers.map(purchaser => {
    const purchaserItems = Array.isArray(purchaser.items)
      ? purchaser.items
      : [];

    return {
      ...purchaser,
      items: purchaserItems.map(item => {
        if (item.type !== CASH_FUND_TYPE) {
          return item;
        }

        const cashPurchase = availabilityByPurchaseId.get(String(item.id));

        if (!cashPurchase) {
          return item;
        }

        const {
          status: availabilityStatus,
          expectedFundsArrivalDate,
        } = cashPurchase;
        const {
          availabilityStatus: ignoredAvailabilityStatus,
          expectedFundsArrivalDate: ignoredExpectedFundsArrivalDate,
          ...baseItem
        } = item;

        return {
          ...baseItem,
          ...(availabilityStatus ? {availabilityStatus} : {}),
          ...(expectedFundsArrivalDate ? {expectedFundsArrivalDate} : {}),
        };
      }),
    };
  });
};

export const getPurchasesCount = (purchasers = []) =>
  purchasers.reduce((acc, curr) => {
    let itemsPurchasedByQuantity = 0;
    const purchaserItems = Array.isArray(curr.items) ? curr.items : [];

    purchaserItems.forEach(item => {
      switch (item.type) {
        case CASH_FUND_TYPE:
        case INTERNAL_GIFT_CARD_PRODUCT_TYPE:
          itemsPurchasedByQuantity += 1;
          break;
        default: {
          const itemQuantity = Number(item.quantity);
          itemsPurchasedByQuantity += Number.isFinite(itemQuantity)
            ? itemQuantity
            : 0;
          break;
        }
      }
    });

    return acc + itemsPurchasedByQuantity;
  }, 0);
